import React from 'react';
import { Translation } from 'react-i18next';

export const TOOLTIP_CONTENT = {
  PROCESSED: (
    <Translation>{(t) => t('ACCESSORIALS_TOOLTIP_PROCESSED')}</Translation>
  ),
  UNITS: <Translation>{(t) => t('ACCESSORIALS_TOOLTIP_UNITS')}</Translation>,
  RATE: <Translation>{(t) => t('ACCESSORIALS_TOOLTIP_RATE')}</Translation>,
  SHIPPER_NOTES: (
    <Translation>{(t) => t('ACCESSORIALS_TOOLTIP_SHIPPER_NOTES')}</Translation>
  ),
  MISSING_DOCS: (
    <Translation>{(t) => t('MISSING_ACCESSORIAL_DOCS')}</Translation>
  ),
  MISSING_EQUIPMENT: (
    <Translation>{(t) => t('NOT_APPLIED_TO_AN_EQUIPMENT')}</Translation>
  ),
  SHIPPER_CHANGED: (
    <Translation>{(t) => t('SHIPPER_CHANGED_NOTE')}</Translation>
  ),
  NO_CARRIER_ASSIGNED_INFO: (
    <Translation>{(t) => t('NO_CARRIER_ASSIGNED_INFO_NOTE')}</Translation>
  ),
  EMPTY_TOOLTIP: null,
};
